import { render, staticRenderFns } from "./formationtile.vue?vue&type=template&id=417eb954&"
import script from "./formationtile.vue?vue&type=script&lang=js&"
export * from "./formationtile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports